import { render, staticRenderFns } from "./NewCar.vue?vue&type=template&id=f93d9654&scoped=true&"
import script from "./NewCar.vue?vue&type=script&lang=js&"
export * from "./NewCar.vue?vue&type=script&lang=js&"
import style0 from "./NewCar.vue?vue&type=style&index=0&id=f93d9654&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f93d9654",
  null
  
)

export default component.exports